import { Params } from 'react-router';
import Toast from '../Toast';
import { ApiResponse, PaginatedApiResponse, axios } from '../config/axios';
import config from '../config/config';

export const TagsService = {
  async all({ per_page, page, search }: any): Promise<PaginatedApiResponse<any>> {
    return await axios.get('/tags', {
      params: {
        per_page,
        page,
        search,
      },
    });
  },
  async allNoPagination(): Promise<ApiResponse<any>> {
    return await axios.get('/tags/all');
  },
  async one(id: Readonly<Params<string>> | undefined): Promise<ApiResponse<any>> {
    return await axios.get(`/tags/${id}`);
  },
  async create(data: { name: string }) {
    try {
      const response: any = await axios.post(`${config.baseUrl}/tags`, data);
      Toast.success(response?.message);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
  async update(id: Readonly<Params<string>> | undefined, data: { name: string }) {
    try {
      const response: any = await axios.patch(`${config.baseUrl}/tags/${id}`, data);
      Toast.success(response?.message);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
  async delete(id: number) {
    try {
      const response = await axios.delete(`${config.baseUrl}/tags/${id}`);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
};

export default TagsService;
